import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ExpandedTooltip, getUtility } from '@livable/saas-react-components';
import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import RippleEffect from 'src/components/general/RippleEffect';
import useStyles from '../styles';
import { isValueNumber } from 'src/utils/typeValidators';
export default function BillingOptOutCell(_ref) {
  var _params$row$billingOp, _params$row, _params$row$billingOp5;
  let params = _ref.params,
    propertyUtilities = _ref.propertyUtilities;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const utilitiesNameById = propertyUtilities === null || propertyUtilities === void 0 ? void 0 : propertyUtilities.reduce((acc, item) => {
    if (item.utilityId) {
      acc[item.utilityId] = item.name;
    }
    return acc;
  }, {});
  const utilityCount = propertyUtilities === null || propertyUtilities === void 0 ? void 0 : propertyUtilities.length;
  const noOptOuts = ((_params$row$billingOp = params.row.billingOptIds) === null || _params$row$billingOp === void 0 ? void 0 : _params$row$billingOp.length) === 0;
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    haveToBePaidUtilities = _useState2[0],
    setHaveToBePaidUtilities = _useState2[1];
  useEffect(() => {
    var _params$row$billingOp2, _params$row$billingOp3;
    if (params.row.vacant) return;
    if (((_params$row$billingOp2 = params.row.billingOptIds) === null || _params$row$billingOp2 === void 0 ? void 0 : _params$row$billingOp2.length) === utilityCount) {
      setHaveToBePaidUtilities([]);
    } else if (noOptOuts) {
      setHaveToBePaidUtilities([...propertyUtilities.map(u => {
        var _params$row$residency;
        const capAmount = (_params$row$residency = params.row.residencyUtilities) === null || _params$row$residency === void 0 || (_params$row$residency = _params$row$residency.find(i => i.utilityId === u.utilityId)) === null || _params$row$residency === void 0 ? void 0 : _params$row$residency.utilityCap;
        if (isValueNumber(capAmount)) {
          return _objectSpread(_objectSpread({}, u), {}, {
            utilityCap: capAmount
          });
        }
        return _objectSpread({}, u);
      })]);
    } else if ((_params$row$billingOp3 = params.row.billingOptIds) !== null && _params$row$billingOp3 !== void 0 && _params$row$billingOp3.length) {
      const unpaidUtilities = [];
      propertyUtilities === null || propertyUtilities === void 0 || propertyUtilities.forEach(item => {
        var _params$row$billingOp4;
        if (!((_params$row$billingOp4 = params.row.billingOptIds) !== null && _params$row$billingOp4 !== void 0 && _params$row$billingOp4.includes(item.utilityId))) {
          var _params$row$residency2;
          const capAmount = (_params$row$residency2 = params.row.residencyUtilities) === null || _params$row$residency2 === void 0 || (_params$row$residency2 = _params$row$residency2.find(i => i.utilityId === item.utilityId)) === null || _params$row$residency2 === void 0 ? void 0 : _params$row$residency2.utilityCap;
          if (isValueNumber(capAmount)) {
            unpaidUtilities.push(_objectSpread(_objectSpread({}, item), {}, {
              utilityCap: capAmount
            }));
          } else {
            unpaidUtilities.push(item);
          }
        }
      });
      setHaveToBePaidUtilities(unpaidUtilities);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const Utilities = _ref2 => {
    let haveToBePaid = _ref2.haveToBePaid;
    let utilities = [];
    if (haveToBePaid) {
      utilities = haveToBePaidUtilities;
    } else {
      params.row.billingOptIds.map(item => {
        utilities.push({
          name: utilitiesNameById[item],
          utilityId: item
        });
      });
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "tooltip-header"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, t("residencies_page.".concat(haveToBePaid ? 'resident_pays_for' : 'resident_does_not_pay_for')))), /*#__PURE__*/React.createElement("div", {
      className: "tooltip-content"
    }, utilities.map(item => {
      const icon = getUtility(item.name).icon();
      return /*#__PURE__*/React.createElement("div", {
        className: classes.billingOpt,
        key: item.utilityId
      }, icon, /*#__PURE__*/React.createElement(Typography, {
        variant: "h5"
      }, /*#__PURE__*/React.createElement(React.Fragment, null, item.name, ' ', isValueNumber(item.utilityCap) && /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        component: 'span'
      }, t("residencies_page.cap_amount", {
        amount: Number(item.utilityCap).toFixed(2)
      })))));
    })));
  };
  const TooltipBillingOutBody = /*#__PURE__*/React.createElement("div", {
    className: classes.tooltipContainer
  }, haveToBePaidUtilities.length ? /*#__PURE__*/React.createElement("div", {
    className: classes.successBlock
  }, /*#__PURE__*/React.createElement(Utilities, {
    haveToBePaid: true
  })) : null, noOptOuts ? null : /*#__PURE__*/React.createElement(Utilities, null));
  return /*#__PURE__*/React.createElement("div", null, params.row.vacant ? /*#__PURE__*/React.createElement("span", {
    className: classes.disabledCellText
  }, "N/A") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    className: classes.tooltip,
    disableInteractive: true,
    hideOnMobile: true,
    placement: "top",
    title: TooltipBillingOutBody,
    type: "utilities-default"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.rippleContainer
  }, /*#__PURE__*/React.createElement(RippleEffect, {
    className: "".concat((_params$row = params.row) !== null && _params$row !== void 0 && _params$row.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " cellContent")
  }, utilityCount - ((_params$row$billingOp5 = params.row.billingOptIds) === null || _params$row$billingOp5 === void 0 ? void 0 : _params$row$billingOp5.length), "/", utilityCount)))));
}